import React from 'react'
import Slider from 'react-slick'
import Partner_1 from '../../../assets/images/patner/partner-two-1.png'
import Partner_2 from '../../../assets/images/patner/partner-two-2.png'
import Partner_3 from '../../../assets/images/patner/partner-two-3.png'
import Partner_4 from '../../../assets/images/patner/partner-two-4.png'
import Partner_5 from '../../../assets/images/patner/partner-two-5.png'

const partSlider = {
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    dots: false,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true
            }
        }
    ]
}


const Partner = () => {

    return (
        <div className="patner-section-two">
            <div className="container">
                <Slider className="patner-slider-two" {...partSlider}>
                    <div className="patner-slide-item-two">
                        <img src={Partner_1} alt="patner-logo" />
                    </div>
                    <div className="patner-slide-item-two">
                        <img src={Partner_2} alt="patner-logo" />
                    </div>
                    <div className="patner-slide-item-two">
                        <img src={Partner_3} alt="patner-logo" />
                    </div>
                    <div className="patner-slide-item-two">
                        <img src={Partner_4} alt="patner-logo" />
                    </div>
                    <div className="patner-slide-item-two">
                        <img src={Partner_5} alt="patner-logo" />
                    </div>
                    <div className="patner-slide-item-two">
                        <img src={Partner_1} alt="patner-logo" />
                    </div>
                    <div className="patner-slide-item-two">
                        <img src={Partner_2} alt="patner-logo" />
                    </div>
                </Slider>
            </div>
        </div>
    )
}

export default Partner
